import {
  Component,
  OnInit,
  Inject,
  OnDestroy,
  ViewEncapsulation,
} from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { ResidentService } from "../resident.service";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from "@angular/material/dialog";
import {
  ResidentGroupForCreationResponse,
  deleteResidentGroup,
} from "../resident";
import { ResGroup, getGroupData, getGroupNotification } from "../../../api";
import { ApiService } from "../../../api.service";
import { AddResidentGroupComponent } from "./add-resident-group/add-resident-group.component";
import { EditresidentgroupComponent } from "./edit-resident-group/edit-resident-group.component";
import {
  enumUIFeatureView,
  enumUIAction,
  enumUIView,
  
} from "../../../app-settings";
import { RollbarService } from "../../../rollbar";
import * as Rollbar from "rollbar";
import {
  SessionCheck,
  generateAlertMessage,
  AuthFailedMessage,
  getFeatureNeedtoShow,
  getAddEditDeleteColumn,
} from "../../../app-general";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ConfirmMessageComponent } from "../../../confirm-message/confirm-message.component";
import { Observable } from "rxjs";
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { distinctUntilChanged, tap } from 'rxjs/operators';


@Component({
  selector: "app-show-resident-group",
  templateUrl: "./show-resident-group.component.html",
  providers: [ResidentService],
  encapsulation: ViewEncapsulation.None,
  styleUrls: ["./show-resident-group.component.scss"],
})
export class showResidentGroupComponent implements OnInit, OnDestroy {
  ResGroup: ResGroup[];
  dataSource;
  dataSourcecount = 1;
  displayedColumns: string[] = [
    "GroupName",
    "Description",
    "Residents",
    "Count",
    "Edit",
    "Delete",
  ];
  smcurrentScreenWidth = "sm";
  xscurrentScreenWidth = "xs";
  resCount = 0;
  bAddEdit = false;
  bDelete = false;
  private _onDestroy: Subject<void> = new Subject<void>();
  authkey;
  public watcher: Observable<boolean>;
  Breakpoints = Breakpoints;
  readonly breakpoint$ = this.breakpointObserver
    .observe([Breakpoints.Large, Breakpoints.Medium, Breakpoints.Small, '(min-width: 500px)'])
    .pipe(
      tap(value => console.log(value)),
      distinctUntilChanged()
    );

  constructor(
    private router: Router,    
    public thisDialogRef: MatDialogRef<showResidentGroupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,
    private residentService: ResidentService,
    @Inject(RollbarService) private rollbar: Rollbar,
    private apiService: ApiService,
    public dialog: MatDialog,
    private breakpointObserver: BreakpointObserver
  ) {    
    this.breakpoint$.subscribe(() => this.breakpointChanged());             
  }
  
  breakpointChanged() {    
    if (getFeatureNeedtoShow(enumUIFeatureView.Resident_Group,enumUIAction.Resident_Group_AddEditDelete) == enumUIView.Show) 
    {
      this.bAddEdit = true;
      this.bDelete = true;
    }
    if(this.breakpointObserver.isMatched(Breakpoints.Large) || this.breakpointObserver.isMatched(Breakpoints.Medium)) {
      this.setupFullTable();
    }     
    else if(this.breakpointObserver.isMatched(Breakpoints.Small)) {
      this.setupTableforsmallerwidth();
    } 
    else if(this.breakpointObserver.isMatched(Breakpoints.XSmall)) {
      this.setupTableforXtrasmallerwidth();
    }
  }

  ngOnInit() {
    this.authkey = localStorage.getItem("Authkey") ?? "";
    if (
      getFeatureNeedtoShow(
        enumUIFeatureView.Resident_Group,
        enumUIAction.Resident_Group_AddEditDelete
      ) == enumUIView.Show
    ) {
      this.bAddEdit = true;
      this.bDelete = true;
    }
    this.getResidentGroup();
  }

  setupTableforXtrasmallerwidth() {
    this.displayedColumns = ["GroupName", "Count", "Edit", "Delete"];
    this.displayedColumns = getAddEditDeleteColumn(
      this.displayedColumns,
      this.bAddEdit,
      this.bDelete
    );
  }

  setupTableforsmallerwidth() {
    this.displayedColumns = [
      "GroupName",
      "Residents",
      "Count",
      "Edit",
      "Delete",
    ];
    this.displayedColumns = getAddEditDeleteColumn(
      this.displayedColumns,
      this.bAddEdit,
      this.bDelete
    );
  }

  setupFullTable() {
    this.displayedColumns = [
      "GroupName",
      "Description",
      "Residents",
      "Count",
      "Edit",
      "Delete",
    ];
    this.displayedColumns = getAddEditDeleteColumn(
      this.displayedColumns,
      this.bAddEdit,
      this.bDelete
    );
  }
  public onCloseCancel = () => {
    this.thisDialogRef.close("Cancel");
    if (!SessionCheck(this.router)) {
      return;
    }
  };

  getResidentGroup(): void {
    try {
      const resgroupitem: getGroupData = {
        authKey: this.authkey,
      };
      this.apiService
        .getResidentGroup(resgroupitem)
        .pipe(takeUntil(this._onDestroy))
        .subscribe((ResGroup: any[]) => {
          if (ResGroup["apiReturn"] == "Invalid Auth Key") {
            this.thisDialogRef.close("Cancel");
            AuthFailedMessage(this.dialog, this.router);
            return;
          }
          this.ResGroup = ResGroup["apiReturn"];
          this.dataSource = new MatTableDataSource(this.ResGroup);
          this.dataSource.data = this.ResGroup;
          this.dataSourcecount = this.dataSource.data.length;
        });
    } catch (err) {
      throw new Error(
        "show-resident-group.component.ts" +
          " - getResidentGroup() - " +
          err.message
      );
    }
  }

  /*********Add Resident group dialogwindow*******/
  AddResidentGroup() {
    if (!SessionCheck(this.router)) {
      this.thisDialogRef.close("Cancel");
      return;
    }
    const dialogRef = this.dialog.open(AddResidentGroupComponent, {
      disableClose: true,
      width: "550px",
      height: "300px",
      panelClass: "myapp-no-padding-dialog",
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == "Confirm") this.getResidentGroup();
      else {
        if (!SessionCheck(this.router)) {
          this.thisDialogRef.close("Cancel");
          return;
        }
      }
    });
  }

  /////////////////*********Edit resident group******/
  editResidentGroupdata(
    Groupid: number,
    Groupname: string,
    description: string
  ) {
    if (!SessionCheck(this.router)) {
      this.thisDialogRef.close("Cancel");
      return;
    }
    const ResidentGroupDetail = {
      GroupId: Groupid,
      Groupname: Groupname,
      Description: description,
    };

    const dialogRef = this.dialog.open(EditresidentgroupComponent, {
      disableClose: true,
      width: "550px",
      height: "300px",
      panelClass: "myapp-no-padding-dialog",
      autoFocus: false,
      data: ResidentGroupDetail,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == "Confirm") this.getResidentGroup();
      else {
        if (!SessionCheck(this.router)) {
          this.thisDialogRef.close("Cancel");
          return;
        }
      }
    });
  }

  ////////////////////Delete Resident Group////////////

  deleteResidentGroupdata(Groupid: number) {
    if (!SessionCheck(this.router)) {
      this.thisDialogRef.close("Cancel");
      return;
    }
    this.getGroupNotificationInfo(Groupid);
  }
  getGroupNotificationInfo(Groupid) {
    try {
      const ConfirmMessageData = {
        ConfirmMessage: "Are you sure you want to delete this Group?",
      };
      const dialogRef = this.dialog.open(ConfirmMessageComponent, {
        disableClose: true,
        width: "auto",
        height: "220px",
        panelClass: "myapp-no-padding-dialog",
        autoFocus: false,
        data: ConfirmMessageData,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result == "Yes") {
          const DeleteResidentgroup: getGroupNotification = {
            authKey: this.authkey,
            groupId: parseInt(Groupid),
            groupType: 0,
          };
          this.apiService
            .getGroupNotificationInfo(DeleteResidentgroup)
            .pipe(takeUntil(this._onDestroy))
            .subscribe((apigroupresponse: any[]) => {
              if (apigroupresponse.toString() == "Success") {
                this.deleteResidentGroup(Groupid);
              } else {
                generateAlertMessage(
                  this.dialog,
                  "This '" +
                    apigroupresponse[0].GroupName +
                    "' is in escalation level, so please remove this group from escalation and try again."
                );
              }
            });
        } else {
          dialogRef.close("Cancel");
          return;
        }
      });
    } catch (err) {
      throw new Error(
        "delete-resident-group.ts" +
          " - getGroupNotificationInfo() - " +
          err.message
      );
    }
  }

  deleteResidentGroup(Groupid) {
    const DeleteResidentgroup: deleteResidentGroup = {
      authKey: this.authkey,
      groupId: parseInt(Groupid),
    };
    this.residentService
      .deleteResidentGroup(DeleteResidentgroup)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((apiresponse: ResidentGroupForCreationResponse[]) => {
        if (apiresponse["apiReturn"] == "Success") {
          generateAlertMessage(
            this.dialog,
            "Resident group deleted successfully."
          );
        } else if (apiresponse["apiReturn"] == "Fail") {
          generateAlertMessage(this.dialog, "Resident group deleted failed.");
        } else if (apiresponse["apiReturn"] == "Invalid Auth Key") {
          this.thisDialogRef.close("Cancel");
          AuthFailedMessage(this.dialog, this.router);
          return;
        } else {
          generateAlertMessage(this.dialog, apiresponse["apiReturn"]);
        }
        this.getResidentGroup();
      });
  }
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
